import React, { useEffect, useState } from 'react';
import OrganizationService from '../../Services/QRCodeServices/OrganizationManagement/OrganizationService';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';

export const OrgSitemap = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 100,
    totalPages: 0,
    totalData: 0,
  });

  const fetchData = async (pageNumber, pageSize) => {
    setLoading(true);
    try {
      const response = await OrganizationService.getOrgList({
        pageNumber,
        pageSize,
      });
      if (response && response.data) {
        setData(response.data); // Set the data for the current page
        console.log(response.totalData, pageSize, pageNumber, response.totalPages);
        setPagination((prev) => ({
          ...prev,
          currentPage: pageNumber,
          pageSize: pageSize,
          totalPages: response.totalPages, // Calculate total pages
          totalData: response.totalData, // Set total number of records
        }));
      } else {
        console.error("Unexpected response structure:", response);
        setData([]);
      }
    } catch (error) {
      toast.error("Error fetching organizations");
      console.error("Error fetching organizations:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.currentPage, pagination.pageSize); // Fetch data when the page or pageSize changes
  }, [pagination.currentPage, pagination.pageSize]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page, // Update the current page
    }));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newPerPage, // Update the number of rows per page
      currentPage: 1, // Reset to the first page when changing the number of rows per page
    }));
  };

  // Function to handle row click
  const handleRowClick = (row) => {
    if (row.link) {
      window.open(row.link, '_blank'); // Open the link in a new tab
    }
  };

  const columns = [
    {
      name: 'S.N',
      selector: (row, index) => (pagination.currentPage - 1) * pagination.pageSize + index + 1,
      sortable: true,
      width: '75px',
    },
    {
      name: 'Org Code',
      selector: (row) => row.code,
      sortable: true,
      width: '100px',
    },
    {
          name: "Name",
          selector: (row) => (
            <div className="d-flex justify-content-center gap-2 align-items-center">
              {row?.displayImagePath && (
                <img
                  src={row?.displayImagePath?.getCDNUrl()}
                  alt={row?.title || "Logo"}
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                />
              )}
              <p>{row?.name}</p>
            </div>
          ),
          sortable: true,
        },
    // {
    //   name: 'Name',
    //   selector: (row) => row.name,
    //   sortable: true,
    // },
    // {
    //   name: 'Logo',
    //   selector: (row) => (
    //     <div className="d-flex gap-2 align-items-center">
    //       {row?.displayImagePath && (
    //         <img
    //           src={row?.displayImagePath?.getCDNUrl()}
    //           alt={row?.title || 'Logo'}
    //           style={{ width: '50px', height: '50px', objectFit: 'cover' }}
    //         />
    //       )}
    //     </div>
    //   ),
    //   sortable: true,
    //   width: '80px',
    // },
    {
      name: 'Link',
      selector: (row) => row.link,
      sortable: true,
      width: 'auto',
      cell: (row) => (
        <a href={row.orgCode} target="_blank" rel="noopener noreferrer">
          {row.orgCode}
        </a>
      ),
    },
    {
      name: 'Address',
      selector: (row) => row.address,
      sortable: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Organization Sitemap List"
          pageTitle="Organization Sitemap"
        />
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressPending={loading}
        pagination={true}
        paginationServer={true}
        paginationTotalRows={pagination.totalData}// Total number of records
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationPerPage={pagination.pageSize} // Set the initial rows per page
        paginationRowsPerPageOptions={[10, 25, 50, 100]} // Allow user to select rows per page
        onRowClicked={handleRowClick} // Handle row click
        pointerOnHover // Show pointer cursor on hover
      />
    </div>
  );
};